import * as React from "react";

export default function useForceUpdate() {
  const [, setState] = React.useState(1);

  return React.useCallback(() => {
    setState((value) => value + 1);
  }, []);
}
